const SvgOrangeClockIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#F79133"
      stroke="#F79133"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M25.666 14c0 6.44-5.226 11.667-11.666 11.667S2.333 20.44 2.333 14 7.56 2.333 14 2.333 25.666 7.56 25.666 14"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m18.328 17.71-3.617-2.158c-.63-.374-1.143-1.272-1.143-2.007V8.762"
    />
  </svg>
);
export default SvgOrangeClockIcon;
